import { formatDate } from './format-date';
import type { DateVariant } from './format-date';

const sameDay = (a: Date, b: Date): boolean =>
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

export const formatDeliveryScheduleDate = (date: Date | string | number, variant: DateVariant = 'date'): string => {
    const target = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;
    if (Number.isNaN(target.getTime())) return '';
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    if (sameDay(target, today)) return 'TODAY';
    if (sameDay(target, tomorrow)) return 'TOMORROW';
    return formatDate(target, variant);
};
